'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.Breakpoints = void 0;
(function(Breakpoints) {
    Breakpoints[Breakpoints["XxxSm"] = 320] = "XxxSm";
    Breakpoints[Breakpoints["XxSm"] = 414] = "XxSm";
    Breakpoints[Breakpoints["XSm"] = 568] = "XSm";
    Breakpoints[Breakpoints["Sm"] = 768] = "Sm";
    Breakpoints[Breakpoints["Md"] = 1024] = "Md";
    Breakpoints[Breakpoints["Lg"] = 1280] = "Lg";
    Breakpoints[Breakpoints["Xl"] = 1366] = "Xl";
    Breakpoints[Breakpoints["Xxl"] = 1600] = "Xxl";
    Breakpoints[Breakpoints["Xxxl"] = 1800] = "Xxxl";
})(exports.Breakpoints || (exports.Breakpoints = {}));
//# sourceMappingURL=breakpoints.js.map
